const BASE_URL = 'https://api.mbbsdunia.com';
// const BASE_URL = 'http://localhost:3232';

export default BASE_URL;            